import { render, staticRenderFns } from "./performance-details-individual-global.vue?vue&type=template&id=3f23767c&"
import script from "./performance-details-individual-global.vue?vue&type=script&lang=js&"
export * from "./performance-details-individual-global.vue?vue&type=script&lang=js&"
import style0 from "./performance-details-individual-global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports